/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_State_CompletedInputs */



/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Tournaments_Lib_State_CompletedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_state_completed = /** @type {((inputs?: Tournaments_Lib_State_CompletedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_State_CompletedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abgeschlossen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminé")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("已结束")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("已完成")
	if (locale === "ko") return /** @type {LocalizedString} */ ("종료")
	return /** @type {LocalizedString} */ ("Completed")
});